import { createFileRoute } from '@tanstack/react-router';
import { theme } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { updateOperatorStatus } from '@/apis/operator.api.ts';
import DigitalCounter from '@/components/DigitalCounter.tsx';
import { Authentication } from '@/rbac';
import {
  useOperatorStore,
  useRemoteOperatorStatus,
} from '@/routes/arc/-stores/operator.store.ts';

export const Route = createFileRoute('/arc/_sip/call/available')({
  component: AvailablePage,
});

function AvailablePage() {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const waitNumber = useOperatorStore((s) => s.waitNumber);
  const operatorStore = useOperatorStore();
  const remoteOperatorStatus = useRemoteOperatorStatus();

  useEffect(() => {
    if (remoteOperatorStatus === 'ACW') {
      // if operator been set to ACW, means the call is missed but the front-end is not aware of it(NOT received the SIP call)
      // set it back to OFFLINE and then set it to AVAILABLE
      updateOperatorStatus({ status: 'OFFLINE' }).then(() => {
        updateOperatorStatus({ status: 'AVAILABLE' }).then(() => {});
      });
    }
  }, [remoteOperatorStatus]);

  if (operatorStore.status !== 'AVAILABLE') {
    return null;
  }

  return (
    <Authentication failMode={'empty'} require={'arc:call:answer'}>
      <div
        className={'fcc fdc h-[80vh] text-[50px]'}
        style={{ color: token.colorPrimary }}
      >
        <div className={'text-[20px]'}>
          {t('arc.widgets.available.AvailablePage.operatorsAhead')}
        </div>
        <div className={'fcc mt-20'}>
          <DigitalCounter className={'text-[100px]'} value={waitNumber ?? 0} />
        </div>
      </div>
    </Authentication>
  );
}
